(function () {
  'use strict';

  // Mobile nav open/close is handled exclusively by assets/header.js
  // (loaded from sections/header.liquid). Do not duplicate that logic
  // here — two handlers bound to the same button/drawer will race
  // each other and the drawer will open then immediately re-close.

  // ---- Product grid filter tabs ----
  document.querySelectorAll('[data-filter-tabs]').forEach(function (tabs) {
    var grid = tabs.closest('section').querySelector('[data-product-grid]');
    var countEl = tabs.closest('section').querySelector('[data-result-count]');
    if (!grid) return;

    tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      tabs.querySelectorAll('.pill').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var filter = btn.getAttribute('data-filter');
      var visible = 0;
      grid.querySelectorAll('[data-product-card]').forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(' ');
        var show = filter === 'all' || tags.indexOf(filter) !== -1;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + ' products';
    });
  });

  // ---- Sort ----
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var section = select.closest('section');
      var grid = section.querySelector('[data-product-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));

      if (select.value === 'low') {
        cards.sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
      } else if (select.value === 'high') {
        cards.sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
      } else {
        cards.sort(function (a, b) { return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10); });
      }
      cards.forEach(function (card) { grid.appendChild(card); });
    });
  });
})();
